import React from 'react';

import { Layout, Label, enums, createComponent } from 'console-kit';

const AuthFooter = createComponent({
  displayName: 'AuthFooter',
  render() {
    return (
      <Layout>
        <Layout.Row>
          <Layout.Column textAlign={enums.textAlignments.CENTER}>
            <Label
              text={
                <span className="auth-footer">
                  <a
                    href="https://getstarted.meetmarigold.com/grow/Content/Welcome.htm"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Help
                  </a>
                  <a href="https://zetaglobal.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
                    Terms of Use
                  </a>
                  <a href="https://zetaglobal.com/platformterms/" target="_blank" rel="noopener noreferrer">
                    Platform Terms
                  </a>
                  <a href="https://zetaglobal.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                  </a>
                  <span>&copy; {new Date().getFullYear()} Zeta. All rights reserved.</span>
                </span>
              }
              hasPadding={false}
              display={enums.display.PLAIN}
              size={enums.sizes.X5}
              isFluid={true}
              color={enums.colors.WHITE}
            />
          </Layout.Column>
        </Layout.Row>
      </Layout>
    );
  },
});

export default AuthFooter;
